import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

// Cookie-based auth: the backend sets an httpOnly `access_token` cookie on
// login/impersonation, and clears it on logout. We must send the cookie
// alongside every request via withCredentials. The frontend NEVER touches the
// token directly — this eliminates the XSS attack surface that localStorage had.
const client = axios.create({ baseURL: API, withCredentials: true });

// Pages reachable while signed out. A 401 here (e.g. AuthContext's own
// GET /auth/me probe on mount) just means "not logged in yet" — expected,
// not a session that needs to be force-redirected away from.
const PUBLIC_PATHS = ["/login", "/forgot-password", "/reset-password"];

client.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!PUBLIC_PATHS.includes(path)) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(err);
  },
);

export default client;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
